import { InjectionToken } from '@angular/core';

export const APP_VERSION = new InjectionToken('AppVersion');
export const APP_NAME = new InjectionToken('AppName');
